<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div v-if="!isReady" class="loading-container">
            <div class="spinner"></div>
          </div>
          <div v-else class="title big">
            {{ $t('THANK YOU FOR YOUR PURCHASE! YOU WILL RECEIVE ALL FILES TO YOUR PROVIDED E-MAIL. IN CASE OF ANY QUESTIONS, PLEASE CONTACT US AT') }}
            {{ $parent.settings ? $parent.settings.support_email.toUpperCase() : '' }}
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

export default {
  name: 'PaymentSuccessPage',
  props: [],
  components: {
  },
  data: function() {
    return {
      isReady: false,
      pollTimer: null,
      isChecking: false,
      pollAttempts: 0,
      maxPollAttempts: 45,
      errorAttempts: 0,
      maxErrorAttempts: 5
    }
  },
  mounted() {
    this.startPolling();
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  },
  methods: {
    getOrderId() {
      // Try vue-router first, then fallback to URLSearchParams
      const fromRoute = this.$route && this.$route.query ? this.$route.query.order_id : null;
      if (fromRoute) return fromRoute;
      const params = new URLSearchParams(window.location.search);
      return params.get('order_id');
    },
    startPolling() {
      const orderId = this.getOrderId();
      if (!orderId) {
        // No order id - don't block the user
        this.isReady = true;
        return;
      }
      // Initial check
      this.checkStatus(orderId);
      // Continue polling until status becomes 1 (success) or 2 (fail)
      this.pollTimer = setInterval(() => {
        if (!this.isReady) {
          this.checkStatus(orderId);
        }
      }, 2000);
    },
    async checkStatus(orderId) {
      if (this.isChecking || this.isReady) return;
      this.isChecking = true;
      try {
        const response = await this.$http.get('orders/status', {
          params: { order_id: orderId }
        });
        const payload = response.data && (response.data.payload || response.data) || {};
        const status = Number(payload.status);
        this.pollAttempts += 1;
        this.errorAttempts = 0;

        if (status === 1) {
          if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
          }
          // Redirect to fail page
          if (this.$router && this.$router.push) {
            this.$router.push('/fail-payment').catch(() => {});
          } else {
            window.location.href = '/fail-payment';
          }
          return;
        }

        if (status === 2) {
          this.isReady = true;
          if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
          }
        }
        // if status === 0 keep polling
        if (this.pollAttempts >= this.maxPollAttempts && !this.isReady) {
          if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
          }
          if (this.$router && this.$router.push) {
            this.$router.push('/fail-payment').catch(() => {});
          } else {
            window.location.href = '/fail-payment';
          }
        }
      } catch (e) {
        const statusCode = e && e.response ? Number(e.response.status) : 0;
        this.errorAttempts += 1;

        // Route missing / forbidden / unauthorized / bad request: stop loop and send to fail page.
        if ([400, 401, 403, 404].includes(statusCode) || this.errorAttempts >= this.maxErrorAttempts) {
          if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
          }
          if (this.$router && this.$router.push) {
            this.$router.push('/fail-payment').catch(() => {});
          } else {
            window.location.href = '/fail-payment';
          }
        }
      } finally {
        this.isChecking = false;
      }
    }
  }
}
</script>
<style scoped>
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 255, 255, 0.25);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
